export class Pagination {
    constructor(objJson, perpage, container, callback) {
        const prevButton = container.parentElement.querySelector("#button_prev");
        const nextButton = container.parentElement.querySelector("#button_next");
        const firstButton = container.parentElement.querySelector("#button_first");
        const lastButton = container.parentElement.querySelector("#button_last");
        const listingTable = container;
        const touchEvent = "ontouchstart" in window ? "touchstart" : "click";


        let current_page = 1;
        let item_per_page = perpage;
        let max_page_number = 5;

        this.init = function () {
            changePage(current_page);
            pageNumbers();
            selectedPage();
            addEventListeners();
        };

        let addEventListeners = function () {
            prevButton.addEventListener(touchEvent, prevPage);
            nextButton.addEventListener(touchEvent, nextPage);
            firstButton.addEventListener(touchEvent, () => {
                current_page = 1;
                changePage(current_page);
            });
            lastButton.addEventListener(touchEvent, () => {
                current_page = numPages();
                changePage(current_page);
            });
        };

        let selectedPage = function () {
            let page_number = container.parentElement
                .querySelector("#page_number")
                .getElementsByClassName("pageButton");
            for (let i = 0; i < page_number.length; i++) {
                if (page_number[i].textContent == current_page) {
                    page_number[i].classList.add("is-active");
                }
            }
        };

        let checkButtonOpacity = function () {
            current_page == 1 ? prevButton.classList.add("disabled") : prevButton.classList.remove("disabled");
            current_page == 1 ? firstButton.classList.add("disabled") : firstButton.classList.remove("disabled");
            current_page == numPages() ? nextButton.classList.add("disabled") : nextButton.classList.remove("disabled");
            current_page == numPages() ? lastButton.classList.add("disabled") : lastButton.classList.remove("disabled");
        };

        let changePage = function (page) {
            if (page < 1) {
                page = 1;
            }
            if (page > numPages() - 1) {
                page = numPages();
            }

            listingTable.innerHTML = "";

            if (objJson.length > 0) {
                for (let i = (page - 1) * item_per_page; i < page * item_per_page && i < objJson.length; i++) {
                    container.appendChild(callback(objJson[i]));
                }
            }else{
                container.appendChild(callback(null));
            }

            pageNumbers();
            checkButtonOpacity();
            selectedPage();
        };

        let prevPage = function () {
            if (current_page > 1) {
                current_page--;
                changePage(current_page);
            }
        };

        let nextPage = function () {
            if (current_page < numPages()) {
                current_page++;
                changePage(current_page);
            }
        };

        let pageNumbers = function () {
            let pageNumber = container.parentElement.querySelector("#page_number");
            pageNumber.innerHTML = "";
            let j;
            let max;
            let add_end_point = false;
            let add_start_point = false;

            if (max_page_number < numPages()) {
                if (current_page - max_page_number / 2 < 1) {
                    j = 1;
                    max = max_page_number;
                    add_end_point = true;
                } else if (parseInt(current_page, 10) + Math.floor(max_page_number / 2) < numPages()) {
                    add_start_point = true;
                    add_end_point = true;

                    j = Math.floor(current_page - max_page_number / 2) + 1;
                    max = parseInt(current_page, 10) + Math.floor(max_page_number / 2);
                } else {
                    j = numPages() - max_page_number;
                    max = numPages();
                    add_start_point = true;
                }
            } else {
                j = 1;
                max = numPages();
            }

            if (add_start_point) {
                const span = document.createElement("span");
                span.classList.add("noclickPageNumber", "pageButton", "notranslate");
                span.textContent = "...";
                pageNumber.appendChild(span);
            }

            for (j; j <= max; j++) {
                const span = document.createElement("span");
                span.classList.add("clickPageNumber", "pageButton", "notranslate");
                span.textContent = j;

                span.addEventListener(touchEvent, function (e) {
                    current_page = e.target.textContent;
                    changePage(current_page);
                });

                pageNumber.appendChild(span);

                pageNumber;
            }

            if (add_end_point) {
                const span = document.createElement("span");
                span.classList.add("noclickPageNumber", "pageButton", "notranslate");
                span.textContent = "...";
                pageNumber.appendChild(span);
            }
        };

        let numPages = function () {
            return Math.ceil(objJson.length / item_per_page);
        };
        if (objJson.length > 0) {
            container.parentElement.querySelector(".pagination-block").classList.remove("d-none");
        }else{
            container.parentElement.querySelector(".pagination-block").classList.add("d-none");
        }
    }
}